export enum PackUnitType {
    Box = 'Box',
    Pallet = 'Pallet',
}

export const PACK_UNIT_TYPES = Object.values(PackUnitType);
